export const HEADER_DESKTOP_PREFIX = "HeaderDesktop";

export const HEADER_DESKTOP_CLASSES = {
  root: `${HEADER_DESKTOP_PREFIX}-root`,
  searchAnimationBox: `${HEADER_DESKTOP_PREFIX}-searchAnimationBox`,
  floor: `${HEADER_DESKTOP_PREFIX}-floor`,
  secondaryLevel: `${HEADER_DESKTOP_PREFIX}-secondaryLevel`,
};
